import {createContext} from "react";
import {ProductType} from "platformed-client/types";

export const ProductContext = createContext<ProductType>("All");
